import TabGroupCanaisAtendimento from '@/components/molecules/TabGroupCanaisAtendimento/TabGroupCanaisAtendimento';
import { CanaisAtendimentoTabs } from '@/data/misc/CanaisAtendimentoTabs';

export default function canaisAtendimento() {
  return <TabGroupCanaisAtendimento tab={CanaisAtendimentoTabs['whatsapp-santander'].id} />;
}

export async function getStaticProps() {
  return {
    props: {},
  };
}
